module.exports = __webpack_public_path__ + "rock.jpg?e1e9c088887260acf3876eb6d0c9188d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rock.jpg
// module id = 25
// module chunks = 0